<template>
  <div>
    <HttpContentView :endpoint="utilities.path('communities/@/servers/all', communityId)" :params="{ serverId: selectedServerId, playerId: playerId }">
      <template v-slot:content="{ data }">
        <div class="d-flex align-items-center flex-wrap g-2 mb-3" v-if="data.length > 1">
          <div v-for="server in data" :key="server.id">
            <ButtonView type="normal" color="secondary" size="small" :active="selectedServerId === server.id" @click="selectedServerId === server.id ? selectedServerId = undefined : selectedServerId = server.id">
              <div class="d-flex align-items-center g-2">
                <i class="fa-duotone fa-server" :style="{ color: server.color }"></i>
                <span>{{ server.name }}</span>
              </div>
            </ButtonView>
          </div>
        </div>
      </template>
    </HttpContentView>
    <CollectionView :endpoint="playerId ? utilities.path('players/@/modules/analytics/sessions', playerId) : utilities.path('communities/@/modules/analytics/sessions', communityId)">
      <template v-slot:header>
        <h4 class="mb-0">{{ translate("sessions") }}</h4>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("player") }}</div>
                <div class="table-header-cell">{{ translate("server") }}</div>
                <div class="table-header-cell">{{ translate("sessions.startedAt") }}</div>
                <div class="table-header-cell">{{ translate("sessions.endedAt") }}</div>
                <div class="table-header-cell">{{ translate("duration") }}</div>
              </div>
              <div class="table-body">
                <div class="table-row" v-for="item in items" :key="item.id">
                  <div class="table-column">
                    <PlayerView :player="item.player"/>
                  </div>
                  <div class="table-column">
                    <Server :server="item.server"/>
                  </div>
                  <div class="table-column">
                    {{ utilities.formatDatetime(item.startedAt) }}
                  </div>
                  <div class="table-column">
                    {{ item.endedAt ? utilities.formatDatetime(item.endedAt) : "" }}
                  </div>
                  <div class="table-column">
                    {{ item.endedAt ? utilities.formatDuration(getDuration(item), true) : "" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
  </div>
</template>

<script setup>
import {ButtonView, HttpContentView, utilities, CollectionView} from "@/niftybit";
import Server from "@/components/other/Server.vue";
import PlayerView from "@/components/other/PlayerView.vue";
import {DateTime} from "luxon";
import {ref} from "vue";

defineProps({
  communityId: String,
  playerId: String
});

const selectedServerId = ref(undefined);

function getDuration(item) {
  return DateTime.fromISO(item.endedAt, { zone: "utc" }).diff(DateTime.fromISO(item.startedAt, { zone: "utc" }), "seconds").seconds;
}

</script>